import loglevel from 'loglevel';

import { getWindowSessionId } from 'zoomforth_zf/appglobals/window-session-id.js';
import { generateUuid } from 'zoomforth_zfutils/unique_identifiers.js';
import {
  getFirebaseConfig,
  getFirebaseWithRetry,
  getAccountScopedFirebaseRef
} from 'zoomforth_zf/appglobals/firebase.js';


const _getEventDatabaseRef = ()=> {
  return getAccountScopedFirebaseRef('/events');
};

const _handleEvent = (snapshot, eventHub)=> {
  if (
    snapshot.val() && 
    // events we make ourself should not be triggered
    snapshot.val().windowSessionId != getWindowSessionId()
  ){
    loglevel.info('Firebase is emitting an event based on the following data:', snapshot.val());
    eventHub.trigger(snapshot.val().event.replace(/ /g,''), snapshot.val().data);
  }
};

export const connectFirebaseEventsToHub = (eventHub)=> {
  /*
    Given an object that implements Backbone.Events (which we call an "eventHub",
    this function wires that object up to be the sole broadcaster of events
    sent to the "/events" firebase system.
  
    We keep the creation of the event hub separate so that we don't need to
    worry about any global state here.
  */
  getFirebaseWithRetry()
    .then(()=> {
      loglevel.info(`Firebase is now listening to events for account ${getFirebaseConfig().accountId}`);

      // we want only one hub to be connected at a time, so turn off any existing listeners
      _getEventDatabaseRef().off('value');

      var isFirstEvent = true;
      _getEventDatabaseRef().on('value', (snapshot)=> {
        if (isFirstEvent) {
          loglevel.info('Firebase event hub is ignoring first event, since we only care about changes since the page loaded.');
          isFirstEvent = false;
          return;
        }

        _handleEvent(snapshot, eventHub);
      });
    })
    .catch(()=> {
      loglevel.info('Firebase is not initialized and will not listen to events');
    });

};

export const triggerFirebaseEvent = (eventName, eventData)=> {
  loglevel.info('Firebase will send an event based on the following data:', eventName, eventData);

  getFirebaseWithRetry()
    .then(()=> {
      _getEventDatabaseRef().set({
        event: eventName,
        data: eventData,
        windowSessionId: getWindowSessionId(),
        // firebase does not listen correctly unless the data changes,
        // so eventUuid changes the data at the location each time by
        // creating a new UUID for each event
        eventUuid: generateUuid()
      });
    })
    .catch(()=> {
      loglevel.info('Firebase is not initialized so sending this event failed.');
    });
};
